import React from 'react'

import Input from 'Components/Input'
import Wysiwyg from 'Components/Wysiwyg'
import Constants from 'EurestoFonction/Constants'

import Grid from '@material-ui/core/Grid'

export default React.memo(props =>
  <Grid container spacing={0} style={{ margin: 0, padding: 0 }} justify={'center'} alignContent={'center'}
    alignItems={'center'} wrap={'nowrap'}>
    <Grid item xs>
      {props.multi ? <Wysiwyg style={props.style}
        inlineWidth={props.inlineWidth}
        title={props.title}
        onChange={props.onChangeSaisieLibre}
        inline={props.inline}
        name={'text'}
        disabled={props.disabled || false}
        data={props.data !== undefined ? (props.infoTiers === true ? props.data.text : "") : ""} /> :
        <Input style={props.style}
          inlineWidth={props.inlineWidth}
          multi={props.multi}
          title={props.title}
          onChange={props.onChangeSaisieLibre}
          name={'text'}
          disabled={props.disabled || false}
          value={props.data !== undefined ? (props.infoTiers === true ? props.data.text : "") : ""}
        />}
    </Grid>
    <Grid item style={{
      margin: 0,
      padding: 10,
      paddingTop: 15,
      display: (!props.data || !props.data.media_lien) && 'none'
    }}>
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '90%', width: '100%' }} justify={'center'}
        alignItems={'center'} alignContent={'center'}>
        <a className={'ei-crm_public'} target="_blank" rel="noopener noreferrer"
          href={props.data !== undefined ? (props.infoTiers === true ? props.data.text : '') : ''} />
      </Grid>
    </Grid>
  </Grid>
)




// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/SaisieLibre.js